import { render, staticRenderFns } from "./CardSalaryTeacher.vue?vue&type=template&id=5fc3097c"
import script from "./CardSalaryTeacher.vue?vue&type=script&lang=js"
export * from "./CardSalaryTeacher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports